import {Request} from "@/Request";

class Account extends Request {
    
    public path: string = '/account';
    
}

export default new Account();